module.exports = {"clients":["local","local_async","local_batch","local_subset","runner","runner_async","ssh","wheel","wheel_async"],"return":"Welcome"}


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/welcome.json
// module id = 1059
// module chunks = 0